module.exports = __webpack_public_path__ + "img/6179a7d.png";